import classNames from 'classnames'
import React from 'react'
import Container from './container'
import Ctas from './ctas'
import Grid from './grid'
import Media from './media'

export default function FeatureImage({ content, media, design }) {
  const { kicker, heading, description, links } = content ?? {}
  const { theme, flip } = design ?? {}

  return (
    <section
      className={classNames(
        'standard-spacing',
        {
          dark: 'bg-secondary text-primary',
          light: 'bg-primary text-secondary'
        }[theme]
      )}>
      <Container>
        <Grid className="items-center">
          {(media?.image || media?.video) && (
            <Media
              className={classNames(
                'rounded-xxx order-2 col-span-12 col-start-1 mt-8 aspect-[4/3] transform-gpu overflow-hidden border-2 md:col-span-10 md:col-start-2 md:mt-0 lg:col-span-5 lg:aspect-[10/9]',
                { light: 'border-secondary', dark: 'border-primary' }[theme],
                ['lg:order-1 lg:col-start-1', 'lg:col-start-8'][+flip]
              )}
              muted
              autoPlay
              cover
              loop
              playsInline
              {...media}
            />
          )}
          <div
            className={classNames(
              'order-1 col-span-12 col-start-1 md:col-span-10 md:col-start-2 lg:col-span-6 xl:col-span-5',
              ['lg:order-2 lg:col-start-7 xl:col-start-8', 'lg:col-start-1'][
                +flip
              ]
            )}>
            {kicker && <div className="accent-lg">{kicker}</div>}
            {heading && <h2 className="heading-3xl mt-4">{heading}</h2>}
            {description && <p className="body-lg mt-4">{description}</p>}
            {links?.buttons && (
              <div className="mt-8">
                <Ctas
                  color={{ dark: 'white', light: 'black' }[theme]}
                  size="sm"
                  {...links}
                />
              </div>
            )}
          </div>
        </Grid>
      </Container>
    </section>
  )
}
